import { saveJournalPhoto } from '../photo-journal';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useStore } from '../store';
import { preparePhotoExport, requestScenePhoto } from '../photo-capture';
/** Existing scene only. Local preview/download, never social sharing or a sim photo score. */
export function PhotoPanel() {
  const { bridge, sim } = useStore();
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('');
  const [url, setUrl] = useState<string | null>(null);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);
  const stillMounted = () => mounted.current;
  const capture = async () => {
    if (busy) return;
    setBusy(true); setStatus('Capturing the current scene...');
    try {
      const photo = await preparePhotoExport(await requestScenePhoto());
      if (!mounted.current) return;
      setUrl(URL.createObjectURL(photo)); setStatus('Photo ready. Review it below, then download the PNG.');
      bridge.send('story.photoCaptured', {});
      try { await saveJournalPhoto(photo, sim.tick); if(stillMounted())setStatus('Saved to Field journal - Photos. Download a PNG for a separate copy.'); }
      catch(err:unknown){if(stillMounted())setStatus(err instanceof Error?err.message:'Photo album unavailable. Download the PNG to keep it.');}
    } catch (err: unknown) {
      if (mounted.current) setStatus(err instanceof Error ? err.message : 'Could not capture this scene. No photo was saved.');
    } finally { if (mounted.current) setBusy(false); }
  };
  return <div style="padding:16px 18px 20px">
    <div class="eyebrow eyebrow-rule">Photo mode</div>
    <p style="font-size:14px;white-space:normal">Capture the current reserve view, without menus or save data. The PNG includes the game credit. Nothing is uploaded. Photos stay in this browser/device and are separate from exported game saves.</p>
    <button class="btn btn-primary" style="width:100%" disabled={busy} onClick={() => { void capture(); }}>{busy ? 'Capturing...' : url ? 'Retake photo' : 'Capture photo'}</button>
    {status && <p role="status" style="font-size:13px;white-space:normal">{status}</p>}
    {url && <><img src={url} alt="Captured reserve view with Exotics Adventure credit" style="display:block;width:100%;height:auto;max-height:320px;object-fit:contain;border:var(--ui-border)"/><a class="btn btn-quiet" style="display:block;text-align:center;margin-top:8px" href={url} download="exotics-adventure-photo.png">Download PNG</a></>}
    <p style="font-size:12px;white-space:normal">Photos are stored locally, separate from exported game saves. Filters and composition scoring are not included.</p>
  </div>;
}
